/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_SarahInputs */

const en_onboarding_rating_sarah = /** @type {(inputs: Onboarding_Rating_SarahInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I use this app every day during my commute. The voice quality is excellent and the UI is clean and intuitive.`)
};

const es_onboarding_rating_sarah = /** @type {(inputs: Onboarding_Rating_SarahInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso esta app todos los días durante mi trayecto. La calidad de voz es excelente y la interfaz es limpia e intuitiva.`)
};

/**
* | output |
* | --- |
* | "I use this app every day during my commute. The voice quality is excellent and the UI is clean and intuitive." |
*
* @param {Onboarding_Rating_SarahInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_sarah = /** @type {((inputs?: Onboarding_Rating_SarahInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_SarahInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_sarah(inputs)
	return en_onboarding_rating_sarah(inputs)
});